<template>
  <div class="create-user">
    <div class="card card-custom card-compact">
      <div class="card-header card-header-nobdr">
        <div class="card-title single-title">
          <h3 class="card-label">Add Payment Mode</h3>
          <span class="sub-title"
            >Please select your preferred payment mode</span
          >
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="payment-listing">
            <v-list>
                <v-list-item v-for="(item, index) in paymentModes" :key="index">
                    <v-list-item-avatar>
                        <div class="payment-logo">
                            {{ item.logoUrl }}
                        </div>
                    </v-list-item-avatar>
                    
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-action>
                        <v-checkbox
                            v-model="selectedModes"
                            :value="item.paymentModeId"
                            ></v-checkbox>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </div>
        <div class="form-popup-footer">
            <v-btn color="grey darken-1" text @click="closePopup">
              Close
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="addPaymentMode"
              :loading="loading"
              :disabled="loading"
            >
              Save
            </v-btn>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddPayment",
  props: {
    paymentModes:{
        type: Array,
        default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedModes: []
    };
  },
  mounted () {
  },
  methods: {
    closePopup() {
      this.selectedModes = [];
      this.$emit("close");
    },
    addPaymentMode() {
        this.$emit("postPaymentMode", this.selectedModes);
        this.selectedModes= [];
        
    }
  }
};
</script>
